import React from "react"
import { Input, theme } from "@omnichannel/ace-b2b-elements"

const CommonInput = React.memo(props => (
  <Input
    fontSize="1.6"
    labelTextProps={{ color: theme.default.grey }}
    placeholderTextColor={theme.default.grey50P}
    {...props}
  />
))

export default CommonInput
